"use client";

import { useState } from "react";
import ExtendedImage from "@/components/ui/extended-image";
import ImageLightbox from "@/components/ui/image-lightbox";

const IMAGE_SIZE = 200;

interface TopicImagesProps {
  imageUrls: string[];
  title: string;
}

const TopicImages = ({ imageUrls, title }: TopicImagesProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  return (
    <>
      <div className="flex gap-2">
        {imageUrls.map((url, i) => (
          <button
            className="rounded-lg overflow-hidden cursor-pointer hover:opacity-80 transition-opacity outline-none focus-visible:ring-2 focus-visible:ring-brand-blue-500"
            key={url}
            onClick={() => setSelectedIndex(i)}
            type="button"
          >
            <ExtendedImage
              alt={title}
              className="border border-gray-200 w-24 h-36 rounded-lg object-cover"
              height={IMAGE_SIZE}
              src={url}
              width={IMAGE_SIZE}
            />
          </button>
        ))}
      </div>
      <ImageLightbox
        images={imageUrls}
        onOpenChange={(open) => {
          if (!open) setSelectedIndex(null);
        }}
        open={selectedIndex !== null}
        startIndex={selectedIndex ?? 0}
      />
    </>
  );
};

export default TopicImages;
